export default {
    name: 'StreamDonationOverviewNewDonation',
    props: {
        previous: {
            type: Boolean,
            default: false
        },
        amount: {
            type: Number,
            default: null
        },
        donorName: {
            type: String,
            default: null
        },
        donationStyle: {
            type: String,
            default: 'normal'
        }
    },
    setup() {}
}
